import {AuthDataModel} from './auth-data.model';

export class CurrentUser {
  public id: string;
  //public username: string;
  //public password: string;
  public firstname: string;
  public lastname: string;
  public fullname: string;
  public nickname: string;
  public userdisplayname: string;
  public webclientid: string;
  public callingapp: string = 'TDOX';
  public returl: string;
  public userid: string;
  public authtoken: string;
  public authdata: AuthDataModel;
  public TDOCID: string;
  public TDOGuid: string;
  public userroles: string[];
  public usergroups: string[];
  public expires_at: string;
}
